import {styled} from "@mui/material/styles"

export const StyledImage = styled("img")`
    margin-bottom: 0.5rem;
    width: 1rem;
    height: 1rem;
`

export const FitsContainer = styled("div")`
    position: absolute;
    left: 0.5rem;
    bottom: 0rem;
    max-width: 1rem;
    z-index: 2;
`
